export enum LanguageLevel {
  VeryBeginner = 'Very Beginner',
  Beginner = 'Beginner',
  Intermediate = 'Intermediate',
  Advanced = 'Advanced',
  Native = 'Native',
}

export const LanguageGrade = [
  {
    value: 'Very Beginner',
    simple: 'Very Beginner',
    clbEquivalent: 'CLB 0-1',
    indexLevel: 1,
  },
  {
    value: 'Beginner',
    simple: 'Beginner',
    clbEquivalent: 'CLB 2-3',
    indexLevel: 3,
  },
  {
    value: 'Intermediate',
    simple: 'Intermediate',
    clbEquivalent: 'CLB 4-5',
    indexLevel: 5,
  },
  {
    value: 'Advanced',
    simple: 'Advanced',
    clbEquivalent: 'CLB 6-7',
    indexLevel: 7,
  },
  { value: 'Native', simple: 'Native', clbEquivalent: '', indexLevel: 12 },
  {
    value: 'A1',
    simple: 'Very Beginner',
    clbEquivalent: 'CLB 0-1',
    indexLevel: 1,
  },
  { value: 'A2', simple: 'Beginner', clbEquivalent: 'CLB 2-3', indexLevel: 3 },
  {
    value: 'B1',
    simple: 'Intermediate',
    clbEquivalent: 'CLB 4-5',
    indexLevel: 5,
  },
  {
    value: 'B2',
    simple: 'Intermediate',
    clbEquivalent: 'CLB 6-7',
    indexLevel: 7,
  },
  {
    value: 'C1',
    simple: 'Advanced',
    clbEquivalent: 'CLB 8-10',
    indexLevel: 10,
  },
  {
    value: 'C2',
    simple: 'Advanced',
    clbEquivalent: 'CLB 11-12',
    indexLevel: 12,
  },
  { value: 'CLB 0', simple: 'Very Beginner', clbEquivalent: '', indexLevel: 0 },
  { value: 'CLB 1', simple: 'Very Beginner', clbEquivalent: '', indexLevel: 1 },
  { value: 'CLB 2', simple: 'Beginner', clbEquivalent: '', indexLevel: 2 },
  { value: 'CLB 3', simple: 'Beginner', clbEquivalent: '', indexLevel: 3 },
  { value: 'CLB 4', simple: 'Beginner', clbEquivalent: '', indexLevel: 4 },
  { value: 'CLB 5', simple: 'Intermediate', clbEquivalent: '', indexLevel: 5 },
  { value: 'CLB 6', simple: 'Intermediate', clbEquivalent: '', indexLevel: 6 },
  { value: 'CLB 7', simple: 'Intermediate', clbEquivalent: '', indexLevel: 7 },
  { value: 'CLB 8', simple: 'Advanced', clbEquivalent: '', indexLevel: 8 },
  { value: 'CLB 9', simple: 'Advanced', clbEquivalent: '', indexLevel: 9 },
  { value: 'CLB 10', simple: 'Advanced', clbEquivalent: '', indexLevel: 10 },
  { value: 'CLB 11', simple: 'Advanced', clbEquivalent: '', indexLevel: 11 },
  { value: 'CLB 12', simple: 'Advanced', clbEquivalent: '', indexLevel: 12 },
];

export const LanguageGradeValues = LanguageGrade.map(
  (grade) => grade.value
) as [string, ...string[]];

export interface Language {
  language: string;
  level: LanguageLevel | null;
}
